import { Routes, Route, Navigate } from "react-router-dom";
import "./index.css";
import LoginPage from "./components/auth/LoginPage";

// =====================================================================
// DECOMMISSIONED — All routes redirect to the decommission notice page.
// Original App component commented out below.
// =====================================================================

function App() {
  return (
    <Routes>
      <Route path="/decommissioned" element={<LoginPage />} />
      <Route path="*" element={<Navigate to="/decommissioned" replace />} />
    </Routes>
  );
}

export default App;

// =====================================================================
// ORIGINAL APP COMPONENT (commented out — do not remove)
// =====================================================================
//
// import React, { useState, useCallback } from "react";
// import { Routes, Route, useNavigate } from "react-router-dom";
// import "./index.css";
// import { Sidebar } from "./components/layout/Sidebar";
// import { ChatInterface } from "./components/chat/ChatInterface";
// import { ResearchView } from "./components/research/ResearchView";
// import { ReportView } from "./components/report/ReportView";
// import { IndexingView } from "./components/indexing";
// import { UploadReportView } from "./components/upload-report";
// import { UserACLPage } from "./components/UserACL";
// import { PageWrapper } from "./components/layout/PageWrapper";
// import DeckBuilderContentPage from "./components/deck-builder/DeckBuilderContentPage";
// import DeckBuilderPreviewPage from "./components/deck-builder/DeckBuilderPreviewPage";
// import FlowBuilderPage from "./components/deck-builder/FlowBuilderPage";
// import { useSocket } from "./hooks/useSocket";
// import { AuthProvider } from "./contexts/AuthContext";
// import ProtectedRoute from "./components/auth/ProtectedRoute";
// import LoginPage from "./components/auth/LoginPage";
// import SAMLCallback from "./components/auth/SAMLCallback";
// import RootHandler from "./components/auth/RootHandler";
// import UnauthorizedPage from "./components/auth/UnauthorizedPage";
// import { authService } from "./services/authService";
// import { SessionTimeoutModal } from "./components/session-timeout";
// import { emitSessionExpired, onSessionExpired } from "./utils/sessionEvents";
// import { config } from "./utils/config";
//
// function App() {
//   const [isSidebarOpen, setIsSidebarOpen] = useState(true);
//   const [refreshTrigger, setRefreshTrigger] = useState(0);
//   const [isSessionTimeoutOpen, setIsSessionTimeoutOpen] = useState(false);
//   const navigate = useNavigate();
//
//   // Connect to WebSocket for global events (like research completion)
//   const { on, off } = useSocket(true);
//
//   // Function to refresh sidebar
//   const refreshSidebar = useCallback(() => {
//     console.log("🔄 App - Triggering sidebar refresh");
//     setRefreshTrigger(prev => prev + 1);
//   }, []);
//
//   const navigateTo = (path: string, state?: any) => {
//     console.log("App navigateTo called with:", { path, state });
//     if (path === "new_chat") {
//       // setIsSidebarOpen(true);
//       navigate("/");
//     } else {
//       navigate(path, { state });
//     }
//   };
//
//   const toggleSidebar = () => setIsSidebarOpen(!isSidebarOpen);
//
//   // Listen for research completion globally to refresh sidebar
//   React.useEffect(() => {
//     const handleResearchComplete = (data: any) => {
//       console.log("🎉 App - Research complete event received, refreshing sidebar");
//       refreshSidebar();
//     };
//
//     console.log("🔗 App - Registering global research_complete listener");
//     on("research_complete", handleResearchComplete);
//
//     return () => {
//       console.log("🔌 App - Cleaning up global research_complete listener");
//       off("research_complete", handleResearchComplete);
//     };
//   }, [on, off, refreshSidebar]);
//
//   React.useEffect(() => {
//     return onSessionExpired(() => {
//       setIsSessionTimeoutOpen(true);
//     });
//   }, []);
//
//   // Global fetch interceptor so API 401s open one consistent timeout modal.
//   React.useEffect(() => {
//     const apiBaseUrl = config.API_BASE_URL.replace(/\/$/, "");
//     const originalFetch = window.fetch.bind(window);
//
//     window.fetch = async (...args: Parameters<typeof fetch>) => {
//       const response = await originalFetch(...args);
//       try {
//         const requestTarget =
//           typeof args[0] === "string"
//             ? args[0]
//             : args[0] instanceof Request
//             ? args[0].url
//             : String(args[0]);
//         const isApiRequest =
//           requestTarget.startsWith(apiBaseUrl) || requestTarget.startsWith("/api/");
//         if (response.status === 401 && isApiRequest) {
//           emitSessionExpired("API returned 401");
//         }
//       } catch (error) {
//         console.warn("Fetch interceptor error:", error);
//       }
//       return response;
//     };
//
//     return () => {
//       window.fetch = originalFetch;
//     };
//   }, []);
//
//   // Keep session checks proactive so non-fetch blob loads are covered quickly.
//   // Uses lightweight session-status endpoint (no ACL DB query).
//   React.useEffect(() => {
//     const apiBaseUrl = config.API_BASE_URL.replace(/\/$/, "");
//
//     const checkSession = async () => {
//       if (!authService.getCurrentUser() || isSessionTimeoutOpen) return;
//       try {
//         const response = await fetch(`${apiBaseUrl}/api/v1/auth/session-status`, {
//           method: "GET",
//           credentials: "include",
//         });
//         if (response.status === 401) {
//           emitSessionExpired("Periodic session check failed");
//         }
//       } catch {
//         // No-op for network issues; modal is only for clear auth-expiry path.
//       }
//     };
//
//     const interval = window.setInterval(checkSession, 90000);
//     const onFocus = () => {
//       void checkSession();
//     };
//     window.addEventListener("focus", onFocus);
//
//     return () => {
//       window.clearInterval(interval);
//       window.removeEventListener("focus", onFocus);
//     };
//   }, [isSessionTimeoutOpen]);
//
//   const handleSessionSignInAgain = async () => {
//     setIsSessionTimeoutOpen(false);
//     await authService.logout();
//     navigate("/login", { replace: true });
//   };
//
//   return (
//     <AuthProvider>
//       <Routes>
//         {/* Public routes */}
//         <Route path="/login" element={<LoginPage />} />
//         <Route path="/auth/saml/acs" element={<SAMLCallback />} />
//
//         {/* Unauthorized route - protected but accessible to authenticated users without ACL */}
//         <Route
//           path="/unauthorized"
//           element={
//             <ProtectedRoute>
//               <UnauthorizedPage />
//             </ProtectedRoute>
//           }
//         />
//
//         {/* Protected routes */}
//         <Route
//           path="/*"
//           element={
//             <ProtectedRoute>
//               <div className="flex h-screen bg-white antialiased text-gray-800">
//                 <Sidebar
//                   isOpen={isSidebarOpen}
//                   toggleSidebar={toggleSidebar}
//                   navigateTo={navigateTo}
//                   refreshTrigger={refreshTrigger}
//                 />
//                 <div className="flex-1 bg-gray-50" style={{overflow: "auto", backgroundColor: '#f2f5f7'}}>
//                   <PageWrapper>
//                     <Routes>
//                       <Route path="/" element={<RootHandler refreshSidebar={refreshSidebar} />} />
//                       <Route path="/research" element={<ResearchView refreshSidebar={refreshSidebar} />} />
//                       <Route path="/report" element={<ReportView refreshSidebar={refreshSidebar} />} />
//                       <Route path="/indexing" element={<IndexingView refreshSidebar={refreshSidebar} />} />
//                       <Route path="/upload-report" element={<UploadReportView refreshSidebar={refreshSidebar} />} />
//                       <Route path="/deck-builder/content" element={<DeckBuilderContentPage />} />
//                       <Route path="/deck-builder/preview" element={<DeckBuilderPreviewPage />} />
//                       <Route path="/deck-builder/flow" element={<FlowBuilderPage />} />
//                       <Route path="/user-acl" element={<UserACLPage />} />
//                       <Route path="/search" element={React.createElement(require('./components/search/ProfessionalSearchPage').default)} />
//                     </Routes>
//                   </PageWrapper>
//                 </div>
//                 <SessionTimeoutModal
//                   isOpen={isSessionTimeoutOpen}
//                   onSignInAgain={handleSessionSignInAgain}
//                 />
//               </div>
//             </ProtectedRoute>
//           }
//         />
//       </Routes>
//     </AuthProvider>
//   );
// }
//
// export default App;
